import { jsxs as i, jsx as l } from "react/jsx-runtime";
import { svgIconStyles as n } from "../svg-icon/SvgIcon.styles.js";
function d({
  label: e,
  className: o,
  size: r,
  ...t
}) {
  return /* @__PURE__ */ i(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "none",
      "data-title": "gallery",
      stroke: "none",
      role: "img",
      "aria-hidden": !e,
      focusable: "false",
      className: n({ className: o, size: r }),
      ...t,
      children: [
        e && /* @__PURE__ */ l("title", { children: e }),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M13 2C13.5523 2 14 2.44772 14 3 14 3.55228 13.5523 4 13 4H6C4.89543 4 4 4.89543 4 6V13C4 13.5523 3.55228 14 3 14 2.44772 14 2 13.5523 2 13V6C2 3.79086 3.79086 2 6 2H13ZM16 12C16.5523 12 17 11.5523 17 11 17 10.4477 16.5523 10 16 10 15.4477 10 15 10.4477 15 11 15 11.5523 15.4477 12 16 12Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22 10C22 7.79086 20.2091 6 18 6H10C7.79086 6 6 7.79086 6 10V18C6 20.2091 7.79086 22 10 22H18C20.2091 22 22 20.2091 22 18V10ZM8 10C8 8.89543 8.89543 8 10 8H18C19.1046 8 20 8.89543 20 10V15.0988L19.0607 14.1595C18.4749 13.5737 17.5251 13.5737 16.9393 14.1595L16.185 14.9138C15.5529 15.546 14.5116 15.4883 13.9531 14.7902L12.1713 12.563C11.5708 11.8123 10.4292 11.8123 9.8287 12.563L8 14.8488V10Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
export {
  d as GalleryIcon,
  d as default
};
